import { render, staticRenderFns } from "./layout-contacts-map.vue?vue&type=template&id=6a63dae7"
import script from "./layout-contacts-map.vue?vue&type=script&lang=js"
export * from "./layout-contacts-map.vue?vue&type=script&lang=js"
import style0 from "./layout-contacts-map.vue?vue&type=style&index=0&id=6a63dae7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports